export interface SetPOCancelledConfirmProps {
  lineCount: number;
  editMode: 'status' | 'currency' | 'both' | null;
}

const getMessage = (lineCount: number, editMode: string | null) => {
  if (lineCount <= 0) return null;

  switch (editMode) {
    case 'status':
      return (
        <>
          The purchase order you are about to cancel is present on {lineCount} line
          {lineCount > 1 ? 's' : ''}.
          <br />
        </>
      );
    case 'currency':
      return (
        <>
          The purchase order whose currency you are about to change is assigned to {lineCount} line
          {lineCount > 1 ? 's' : ''}.
          <br />
          These purchase orders will be unassigned. &nbsp;
        </>
      );
    case 'both':
      return (
        <>
          The purchase order you are about to cancel and change the currency for is assigned to{' '}
          {lineCount} line{lineCount > 1 ? 's' : ''}.
          <br />
          These purchase orders will be unassigned.&nbsp;
        </>
      );
    default:
      return null;
  }
};

const SetPOCancelledConfirm = ({ lineCount, editMode }: SetPOCancelledConfirmProps) => (
  <div>
    {getMessage(lineCount, editMode)}
    Are you sure you wish to continue?
  </div>
);

export default SetPOCancelledConfirm;
